import { MY_ACCOUNT_URL } from '@src/configs';

export const APPLE_RANDOM_EMAIL_SUFFIXES = '@privaterelay.appleid.com';

export const FACEBOOK_RANDOM_EMAIL_SUFFIXES = '@private.vbee.vn';

export const PROVIDE_EMAIL_URL = `${MY_ACCOUNT_URL}/add-email`;

export const HAS_OPENED_REQUIRE_PROVIDE_EMAIL_DIALOG =
  'has-opened-require-provide-email-dialog';
